module.exports = __webpack_public_path__ + "static/media/profile1.7e97b893.jpg";